import styles from "./TabNavigation.module.scss";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React from "react";

interface ITabNavigationProps {
  items: {
    text: string;
    to: string;
  }[];
}

const TabNavigation: React.FC<ITabNavigationProps> = ({ items }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      {items.map((el, index) => {
        return (
          <NavLink
            key={index}
            className={({ isActive }) =>
              isActive ? `${styles.link} ${styles.active}` : styles.link
            }
            to={el.to}
          >
            {t(el.text)}
          </NavLink>
        );
      })}
    </div>
  );
};

export default TabNavigation;
